<template>
  <div>
    <FlightDetailsBottomSheet
      source-page="passengersData"
      :dict="dict"
      :flights-list="flights"
      :name="detailsBottomSheetName"
      :city-mismatches="cityMismatches"
      :is-multimodal="isMultimodal"
    />
    <div
      v-if="isMultimodal"
      class="bg-background-neutral-secondary mb-4 flex items-start gap-3 rounded-2xl p-4"
    >
      <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#1D6BC0]/10 text-[#1D6BC0]"
        aria-hidden="true"
      >
        <TrainIcon class="h-5 w-5" />
      </div>
      <div>
        <p class="text-text-neutral-primary text-base font-medium">
          {{ $t('passengersData.railNotice.title') }}
        </p>
        <i18n-t
          tag="p"
          keypath="passengersData.railNotice.description"
          class="text-text-neutral-quaternary mt-1 text-sm"
        >
          <template #link>
            <a
              :href="RAIL_CHECKIN_URL"
              class="text-[#1D6BC0] underline"
              @click.prevent="openRailCheckIn"
            >
              {{ $t('passengersData.railNotice.linkLabel') }}
            </a>
          </template>
        </i18n-t>
      </div>
    </div>
    <FlightDetailsCollapsed
      class="mx-4 mb-8"
      source-page="passengersData"
      :flights="flights"
      :dict="dict"
      :count-passengers="countPassengers"
      :is-youth="isYouth"
      :search-query="searchQuery"
      @onCardClick="bottomSheet.show(detailsBottomSheetName)"
    />
  </div>
</template>

<script setup lang="ts">
  import { controllerModel, type ticketDetails } from 'shared';
  import { FlightDetailsBottomSheet, freedomApp } from 'freedom-shared';
  import TrainIcon from 'freedom-shared/src/assets/images/train.svg?component';
  import type { Dict } from '@aviata/platform-types';

  import { FlightDetailsCollapsed } from '@/features/flight-details';

  const RAIL_CHECKIN_URL = 'https://www.rail-checkin.com/';

  defineProps<{
    flights: ticketDetails.types.MappedFlight[];
    dict: Dict.Entity;
    cityMismatches: ticketDetails.types.MismatchedCity[];
    countPassengers: number;
    isYouth: boolean;
    searchQuery?: string | null;
    isMultimodal?: boolean;
  }>();

  const openRailCheckIn = () => {
    if (import.meta.env.VITE_RUNTIME_ENV === 'development') {
      window.open(RAIL_CHECKIN_URL, '_blank')?.focus();
      return;
    }
    freedomApp.lib.navigate(RAIL_CHECKIN_URL);
  };

  const detailsBottomSheetName = 'passengers-form-details-bottom-sheet';
  const bottomSheet = controllerModel.useBottomSheet();
</script>
